import React from 'react';

import {
  BrandContainer,
  BrandImage,
  CardIcon,
  StatusBadge,
  StatusBadgeIcon,
  StatusBadgeText,
  Container,
  BoldValue,
  Date,
  Infos,
  InfoIcon,
  InfoRow,
  LeftContent,
  LinkButton,
  LinkButtonText,
  Payment,
  PaymentDate,
  PaymentMethodLeft,
  PaymentMethodInfo,
  PaymentTitle,
  ReembolsoBadges,
  SeeMoreButton,
  SeeMoreButtonText,
} from './styles';
import {useHelpers} from '../../../../context/helpers';
import {ReembolsoSolicitacao} from '../../../../dtos/ReembolsoDTO';
import {useTheme} from 'styled-components/native';

interface Props {
  data: ReembolsoSolicitacao;
  index: number;
}

export function AcompanhaReembolso({data, index}: Props) {
  const {formatNumberToLocaleAmount} = useHelpers();
  const theme = useTheme();
  const [isPrazoExpanded, setIsPrazoExpanded] = React.useState(false);
  const isPix = data.meioPagamento === 'PIX';

  const prazoEstornoTexto = (data.prazo_estorno ?? '').trim();
  const isPrazoLongo = prazoEstornoTexto.length > 100;
  const prazoParaExibir =
    isPrazoLongo && !isPrazoExpanded
      ? `${prazoEstornoTexto.slice(0, 100)}...`
      : prazoEstornoTexto;

  const formatDate = (dateString: string) => {
    try {
      const date = dateString.replaceAll('-', '/');
      return date;
    } catch (error) {
      return dateString;
    }
  };

  const statusRaw = (data.status ?? '').trim();
  const statusLower = statusRaw.toLowerCase();

  const getStatusStyle = () => {
    if (statusLower.includes('solicit')) {
      return {
        icon: 'clock-o',
        bgColor: theme.colors.orange_opacity,
        borderColor: theme.colors.orange,
        textColor: theme.colors.orange,
      };
    }
    if (statusLower.includes('marcado') || statusLower.includes('analis')) {
      return {
        icon: 'info-circle',
        bgColor: theme.colors.blue_opacity,
        borderColor: theme.colors.blue,
        textColor: theme.colors.blue,
      };
    }
    if (
      statusLower.includes('aprov') ||
      statusLower.includes('efetu') ||
      statusLower.includes('conclu') ||
      statusLower.includes('pago')
    ) {
      return {
        icon: 'check-circle',
        bgColor: theme.colors.green_light,
        borderColor: theme.colors.success,
        textColor: theme.colors.success,
      };
    }
    if (
      statusLower.includes('cancel') ||
      statusLower.includes('rejeit') ||
      statusLower.includes('negad')
    ) {
      return {
        icon: 'times-circle',
        bgColor: theme.colors.red_light,
        borderColor: theme.colors.attention,
        textColor: theme.colors.attention,
      };
    }
    return {
      icon: 'tag',
      bgColor: theme.colors.border3,
      borderColor: theme.colors.border,
      textColor: theme.colors.text,
    };
  };

  const statusStyle = getStatusStyle();
  return (
    <Container>
      <LeftContent>
        <Infos>
          <Payment>
            <PaymentMethodInfo>
              <PaymentMethodLeft>
                <PaymentTitle>
                  {data.meioPagamento === 'CCT' ? 'Crédito' : data.meioPagamento}
                </PaymentTitle>
                <BrandContainer>
                  {isPix ? (
                    <BrandImage
                      resizeMode="contain"
                      source={{
                        uri: 'https://d3ag5cip9ldvh3.cloudfront.net/card_brands/pix.png',
                      }}
                    />
                  ) : (
                    <CardIcon name="credit-card" />
                  )}
                </BrandContainer>
              </PaymentMethodLeft>

              <PaymentDate>
                {data.data_solicitacao ? formatDate(data.data_solicitacao) : ''}
              </PaymentDate>
            </PaymentMethodInfo>
          </Payment>

          <InfoRow>
            <InfoIcon name="tag" />
            <Date>
              Valor:{' '}
              <BoldValue>
                {formatNumberToLocaleAmount(data.valorReembolso) ?? 'R$ 0,00'}
              </BoldValue>
            </Date>
          </InfoRow>

          {data.banco && (
            <InfoRow>
              <InfoIcon name="university" />
              <Date>
                Banco: <BoldValue>{data.banco}</BoldValue>
              </Date>
            </InfoRow>
          )}

          {data.agencia != null ? (
            <InfoRow>
              <InfoIcon name="building" />
              <Date>
                Agência: <BoldValue>{data.agencia}</BoldValue>
              </Date>
            </InfoRow>
          ) : null}

          {data.conta !== null ? (
            <InfoRow>
              <InfoIcon name="credit-card" />
              <Date>
                Conta: <BoldValue>{data.conta}</BoldValue>
              </Date>
            </InfoRow>
          ) : null}

          <ReembolsoBadges>
            <StatusBadge
              bgColor={statusStyle.bgColor}
              borderColor={statusStyle.borderColor}>
              <StatusBadgeIcon
                name={statusStyle.icon as any}
                color={statusStyle.textColor}
              />
              <StatusBadgeText style={{color: statusStyle.textColor}}>
                {statusRaw || 'Status'}
              </StatusBadgeText>
            </StatusBadge>
          </ReembolsoBadges>

          {prazoEstornoTexto.length > 0 && (
            <>
              <Date>{prazoParaExibir}</Date>

              {isPrazoLongo && (
                <SeeMoreButton onPress={() => setIsPrazoExpanded(prev => !prev)}>
                  <SeeMoreButtonText>
                    {isPrazoExpanded ? 'Ler menos' : 'Ler mais'}
                  </SeeMoreButtonText>
                </SeeMoreButton>
              )}
            </>
          )}
        </Infos>
      </LeftContent>
    </Container>
  );
}
